export const functionCategories = [
    {
        key: "math",
        label: "Matematik",
        functions: [
            { name: "ABS", description: "Mutlak değer alır", syntax: "ABS(sayı)" },
            { name: "ACOS", description: "Ark kosinüs hesaplar", syntax: "ACOS(sayı)" },
            { name: "ACOSH", description: "Hiperbolik ark kosinüs hesaplar", syntax: "ACOSH(sayı)" },
            { name: "ACOT", description: "Ark kotanjant hesaplar", syntax: "ACOT(sayı)" },
            { name: "ACOTH", description: "Hiperbolik ark kotanjant hesaplar", syntax: "ACOTH(sayı)" },
            {
                name: "AGGREGATE",
                description: "Listedeki değerlerin toplamını, ortalamasını vb. hesaplar",
                syntax: "AGGREGATE(fonksiyon_kodu, seçenekler, dizi1, [dizi2, ...])",
            },
            { name: "ARABIC", description: "Roma rakamlarını ondalık sayıya dönüştürür", syntax: "ARABIC(metin)" },
            { name: "ASIN", description: "Ark sinüs hesaplar", syntax: "ASIN(sayı)" },
            { name: "ASINH", description: "Hiperbolik ark sinüs hesaplar", syntax: "ASINH(sayı)" },
            { name: "ATAN", description: "Ark tanjant hesaplar", syntax: "ATAN(sayı)" },
            { name: "ATAN2", description: "İki koordinattan ark tanjant hesaplar", syntax: "ATAN2(y, x)" },
            { name: "ATANH", description: "Hiperbolik ark tanjant hesaplar", syntax: "ATANH(sayı)" },
            {
                name: "AVERAGE",
                description: "Değerlerin ortalamasını hesaplar",
                syntax: "AVERAGE(sayı1, [sayı2, ...])",
            },
            {
                name: "BASE",
                description: "Bir sayıyı verilen tabanda metin olarak gösterir",
                syntax: "BASE(sayı, taban, [min_uzunluk])",
            },
            {
                name: "CEILING",
                description: "Sayıyı en yakın üst tam sayıya yuvarlar",
                syntax: "CEILING(sayı, [hassasiyet], [mod])",
            },
            {
                name: "CEILINGMATH",
                description: "Sayıyı hassasiyetin en yakın katına yuvarlar",
                syntax: "CEILINGMATH(sayı, [hassasiyet], [mod])",
            },
            {
                name: "CEILINGPRECISE",
                description: "Sayıyı hassasiyetin en yakın katına yuvarlar (işaret duyarlı)",
                syntax: "CEILINGPRECISE(sayı, [hassasiyet])",
            },
            { name: "COMBIN", description: "Belirli sayıda öğenin kombinasyonlarını hesaplar", syntax: "COMBIN(n, k)" },
            { name: "COMBINA", description: "Tekrarlı kombinasyonları hesaplar", syntax: "COMBINA(n, k)" },
            { name: "COS", description: "Kosinüs hesaplar", syntax: "COS(sayı)" },
            { name: "COSH", description: "Hiperbolik kosinüs hesaplar", syntax: "COSH(sayı)" },
            { name: "COT", description: "Kotanjant hesaplar", syntax: "COT(sayı)" },
            { name: "COTH", description: "Hiperbolik kotanjant hesaplar", syntax: "COTH(sayı)" },
            { name: "COUNT", description: "Değerlerin sayısını hesaplar", syntax: "COUNT(değer1, [değer2, ...])" },
            { name: "CSC", description: "Kosekant hesaplar", syntax: "CSC(sayı)" },
            { name: "CSCH", description: "Hiperbolik kosekant hesaplar", syntax: "CSCH(sayı)" },
            {
                name: "DECIMAL",
                description: "Belirli bir tabandaki metin gösterimini ondalık sayıya dönüştürür",
                syntax: "DECIMAL(metin, taban)",
            },
            { name: "EVEN", description: "Sayıyı en yakın çift tam sayıya yuvarlar", syntax: "EVEN(sayı)" },
            { name: "EXP", description: "e üzeri x değerini hesaplar", syntax: "EXP(sayı)" },
            { name: "FACT", description: "Faktöriyel hesaplar", syntax: "FACT(sayı)" },
            { name: "FACTDOUBLE", description: "Çift faktöriyel hesaplar", syntax: "FACTDOUBLE(sayı)" },
            {
                name: "FLOOR",
                description: "Sayıyı en yakın alt tam sayıya yuvarlar",
                syntax: "FLOOR(sayı, [hassasiyet])",
            },
            {
                name: "FLOORMATH",
                description: "Sayıyı aşağı yuvarlar (matematiksel)",
                syntax: "FLOORMATH(sayı, [hassasiyet], [mod])",
            },
            {
                name: "FLOORPRECISE",
                description: "Sayıyı hassasiyetin en yakın alt katına yuvarlar (işaret duyarlı)",
                syntax: "FLOORPRECISE(sayı, [hassasiyet])",
            },
            { name: "GCD", description: "En büyük ortak böleni hesaplar", syntax: "GCD(sayı1, [sayı2, ...])" },
            { name: "INT", description: "Sayıyı en yakın alt tam sayıya yuvarlar", syntax: "INT(sayı)" },
            { name: "ISEVEN", description: "Sayının çift olup olmadığını kontrol eder", syntax: "ISEVEN(sayı)" },
            {
                name: "ISOCEILING",
                description: "ISO standartlarına göre yukarı yuvarlar",
                syntax: "ISOCEILING(sayı, [hassasiyet])",
            },
            { name: "ISODD", description: "Sayının tek olup olmadığını kontrol eder", syntax: "ISODD(sayı)" },
            { name: "LCM", description: "En küçük ortak katı hesaplar", syntax: "LCM(sayı1, [sayı2, ...])" },
            { name: "LN", description: "Doğal logaritma hesaplar", syntax: "LN(sayı)" },
            { name: "LOG", description: "Belirli tabanda logaritma hesaplar", syntax: "LOG(sayı, [taban])" },
            { name: "LOG10", description: "10 tabanında logaritma hesaplar", syntax: "LOG10(sayı)" },
            { name: "MAX", description: "En büyük değeri bulur", syntax: "MAX(sayı1, [sayı2, ...])" },
            { name: "MIN", description: "En küçük değeri bulur", syntax: "MIN(sayı1, [sayı2, ...])" },
            { name: "MOD", description: "Bölme işleminden kalan değeri hesaplar", syntax: "MOD(sayı, bölen)" },
            {
                name: "MROUND",
                description: "Sayıyı belirtilen değerin en yakın katına yuvarlar",
                syntax: "MROUND(sayı, kat)",
            },
            {
                name: "MULTINOMIAL",
                description: "Multinomial katsayısını hesaplar",
                syntax: "MULTINOMIAL(sayı1, [sayı2, ...])",
            },
            { name: "ODD", description: "Sayıyı en yakın tek tam sayıya yuvarlar", syntax: "ODD(sayı)" },
            { name: "POWER", description: "Üs alır", syntax: "POWER(sayı, üs)" },
            { name: "PRODUCT", description: "Argümanların çarpımını hesaplar", syntax: "PRODUCT(sayı1, [sayı2, ...])" },
            { name: "QUOTIENT", description: "Bölme işleminin tam kısmını hesaplar", syntax: "QUOTIENT(pay, payda)" },
            { name: "RADIANS", description: "Dereceyi radyana dönüştürür", syntax: "RADIANS(açı)" },
            { name: "RAND", description: "0 ile 1 arasında rastgele sayı üretir", syntax: "RAND()" },
            {
                name: "RANDBETWEEN",
                description: "Belirtilen iki değer arasında rastgele tam sayı üretir",
                syntax: "RANDBETWEEN(alt, üst)",
            },
            { name: "ROUND", description: "Sayıyı yuvarlar", syntax: "ROUND(sayı, [ondalık_basamak])" },
            { name: "ROUNDDOWN", description: "Sayıyı aşağı yuvarlar", syntax: "ROUNDDOWN(sayı, ondalık_basamak)" },
            { name: "ROUNDUP", description: "Sayıyı yukarı yuvarlar", syntax: "ROUNDUP(sayı, ondalık_basamak)" },
            { name: "SEC", description: "Sekant hesaplar", syntax: "SEC(sayı)" },
            { name: "SECH", description: "Hiperbolik sekant hesaplar", syntax: "SECH(sayı)" },
            { name: "SIGN", description: "Sayının işaretini döndürür (-1, 0, 1)", syntax: "SIGN(sayı)" },
            { name: "SIN", description: "Sinüs hesaplar", syntax: "SIN(sayı)" },
            { name: "SINH", description: "Hiperbolik sinüs hesaplar", syntax: "SINH(sayı)" },
            { name: "SQRT", description: "Karekök hesaplar", syntax: "SQRT(sayı)" },
            {
                name: "SQRTPI",
                description: "Pi sayısı ile çarpılmış sayının karekökünü hesaplar",
                syntax: "SQRTPI(sayı)",
            },
            {
                name: "SUBTOTAL",
                description: "Bir listede alt toplam hesaplar",
                syntax: "SUBTOTAL(fonksiyon_kodu, dizi1, [dizi2, ...])",
            },
            { name: "SUM", description: "Değerlerin toplamını hesaplar", syntax: "SUM(sayı1, [sayı2, ...])" },
            {
                name: "SUMIF",
                description: "Koşulu sağlayan değerleri toplar",
                syntax: "SUMIF(dizi, koşul, [toplam_dizi])",
            },
            {
                name: "SUMIFS",
                description: "Birden fazla koşulu sağlayan değerleri toplar",
                syntax: "SUMIFS(toplam_dizi, koşul_dizi1, koşul1, [koşul_dizi2, koşul2, ...])",
            },
            {
                name: "SUMPRODUCT",
                description: "Dizilerin çarpımlarının toplamını hesaplar",
                syntax: "SUMPRODUCT(dizi1, [dizi2, ...])",
            },
            { name: "SUMSQ", description: "Karelerin toplamını hesaplar", syntax: "SUMSQ(sayı1, [sayı2, ...])" },
            {
                name: "SUMX2MY2",
                description: "İki dizinin karelerinin farkının toplamını hesaplar",
                syntax: "SUMX2MY2(dizi_x, dizi_y)",
            },
            {
                name: "SUMX2PY2",
                description: "İki dizinin karelerinin toplamını hesaplar",
                syntax: "SUMX2PY2(dizi_x, dizi_y)",
            },
            {
                name: "SUMXMY2",
                description: "İki dizinin farklarının karelerinin toplamını hesaplar",
                syntax: "SUMXMY2(dizi_x, dizi_y)",
            },
            { name: "TAN", description: "Tanjant hesaplar", syntax: "TAN(sayı)" },
            { name: "TANH", description: "Hiperbolik tanjant hesaplar", syntax: "TANH(sayı)" },
            { name: "TRUNC", description: "Sayının ondalık kısmını keser", syntax: "TRUNC(sayı, [ondalık_basamak])" },
        ],
    },
    {
        key: "statistics",
        label: "İstatistik",
        functions: [
            { name: "AVEDEV", description: "Ortalama mutlak sapma", syntax: "AVEDEV(sayı1, [sayı2, ...])" },
            { name: "AVERAGE", description: "Aritmetik ortalama hesaplar", syntax: "AVERAGE(sayı1, [sayı2, ...])" },
            {
                name: "AVERAGEA",
                description: "Metin ve mantıksal değerleri de içeren aritmetik ortalama",
                syntax: "AVERAGEA(değer1, [değer2, ...])",
            },
            {
                name: "AVERAGEIF",
                description: "Belirli bir koşulu sağlayan değerlerin ortalaması",
                syntax: "AVERAGEIF(aralık, kriter, [ortalama_aralığı])",
            },
            {
                name: "AVERAGEIFS",
                description: "Birden fazla koşulu sağlayan değerlerin ortalaması",
                syntax: "AVERAGEIFS(ortalama_aralığı, kriter_aralığı1, kriter1, [kriter_aralığı2, kriter2, ...])",
            },
            {
                name: "BETADIST",
                description: "Beta dağılımının kümülatif olasılık yoğunluk fonksiyonu",
                syntax: "BETADIST(x, alfa, beta, [A], [B])",
            },
            {
                name: "BETAINV",
                description: "Beta dağılımının ters kümülatif olasılık yoğunluk fonksiyonu",
                syntax: "BETAINV(olasılık, alfa, beta, [A], [B])",
            },
            {
                name: "BINOMDIST",
                description: "Binom dağılımı olasılığı",
                syntax: "BINOMDIST(başarı_sayısı, deneme_sayısı, başarı_olasılığı, kümülatif)",
            },
            {
                name: "CORREL",
                description: "İki veri kümesi arasındaki korelasyon katsayısı",
                syntax: "CORREL(dizi1, dizi2)",
            },
            {
                name: "COUNT",
                description: "Sayısal değerlerin sayısını hesaplar",
                syntax: "COUNT(değer1, [değer2, ...])",
            },
            {
                name: "COUNTA",
                description: "Boş olmayan değerlerin sayısını hesaplar",
                syntax: "COUNTA(değer1, [değer2, ...])",
            },
            { name: "COUNTBLANK", description: "Boş değerlerin sayısını hesaplar", syntax: "COUNTBLANK(aralık)" },
            {
                name: "COUNTIF",
                description: "Belirli bir koşulu sağlayan değerlerin sayısı",
                syntax: "COUNTIF(aralık, kriter)",
            },
            {
                name: "COUNTIFS",
                description: "Birden fazla koşulu sağlayan değerlerin sayısı",
                syntax: "COUNTIFS(aralık1, kriter1, [aralık2, kriter2, ...])",
            },
            {
                name: "COUNTUNIQUE",
                description: "Benzersiz değerlerin sayısını hesaplar",
                syntax: "COUNTUNIQUE(değer1, [değer2, ...])",
            },
            { name: "COVARIANCEP", description: "Ana kütle kovaryansı", syntax: "COVARIANCEP(dizi1, dizi2)" },
            { name: "COVARIANCES", description: "Örneklem kovaryansı", syntax: "COVARIANCES(dizi1, dizi2)" },
            { name: "DEVSQ", description: "Kareler sapması", syntax: "DEVSQ(sayı1, [sayı2, ...])" },
            { name: "EXPONDIST", description: "Üstel dağılım", syntax: "EXPONDIST(x, lambda, kümülatif)" },
            {
                name: "FDIST",
                description: "F dağılımı olasılığı",
                syntax: "FDIST(x, serbestlik_derecesi1, serbestlik_derecesi2)",
            },
            {
                name: "FINV",
                description: "F dağılımının tersi",
                syntax: "FINV(olasılık, serbestlik_derecesi1, serbestlik_derecesi2)",
            },
            { name: "FISHER", description: "Fisher dönüşümü", syntax: "FISHER(x)" },
            { name: "FISHERINV", description: "Fisher dönüşümünün tersi", syntax: "FISHERINV(y)" },
            { name: "FORECAST", description: "Doğrusal trend tahmini", syntax: "FORECAST(x, bilinen_y, bilinen_x)" },
            { name: "FREQUENCY", description: "Frekans dağılımı", syntax: "FREQUENCY(veri_dizisi, sınıflar_dizisi)" },
            { name: "GAMMA", description: "Gamma fonksiyonu", syntax: "GAMMA(sayı)" },
            { name: "GAMMALN", description: "Gamma fonksiyonunun doğal logaritması", syntax: "GAMMALN(sayı)" },
            { name: "GAUSS", description: "Standart normal kümülatif dağılımın 0.5 eksiği", syntax: "GAUSS(z)" },
            { name: "GEOMEAN", description: "Geometrik ortalama", syntax: "GEOMEAN(sayı1, [sayı2, ...])" },
            {
                name: "GROWTH",
                description: "Üstel trend tahmini",
                syntax: "GROWTH(bilinen_y, [bilinen_x], [yeni_x], [sabit])",
            },
            { name: "HARMEAN", description: "Harmonik ortalama", syntax: "HARMEAN(sayı1, [sayı2, ...])" },
            {
                name: "HYPGEOMDIST",
                description: "Hipergeometrik dağılım",
                syntax: "HYPGEOMDIST(örnek_başarı, örnek_büyüklük, popülasyon_başarı, popülasyon_büyüklük)",
            },
            {
                name: "INTERCEPT",
                description: "Doğrusal regresyon kesişim noktası",
                syntax: "INTERCEPT(bilinen_y, bilinen_x)",
            },
            { name: "KURT", description: "Basıklık", syntax: "KURT(sayı1, [sayı2, ...])" },
            { name: "LARGE", description: "En büyük k. değer", syntax: "LARGE(dizi, k)" },
            {
                name: "LINEST",
                description: "Doğrusal regresyon parametreleri",
                syntax: "LINEST(bilinen_y, [bilinen_x], [sabit], [istatistikler])",
            },
            {
                name: "LOGNORMDIST",
                description: "Logaritmik normal dağılım",
                syntax: "LOGNORMDIST(x, ortalama, standart_sapma, kümülatif)",
            },
            {
                name: "LOGNORMINV",
                description: "Logaritmik normal dağılımın tersi",
                syntax: "LOGNORMINV(olasılık, ortalama, standart_sapma)",
            },
            { name: "MAX", description: "En büyük değer", syntax: "MAX(sayı1, [sayı2, ...])" },
            {
                name: "MAXA",
                description: "En büyük değer (metin ve mantıksal değerler dahil)",
                syntax: "MAXA(değer1, [değer2, ...])",
            },
            { name: "MEDIAN", description: "Medyan", syntax: "MEDIAN(sayı1, [sayı2, ...])" },
            { name: "MIN", description: "En küçük değer", syntax: "MIN(sayı1, [sayı2, ...])" },
            {
                name: "MINA",
                description: "En küçük değer (metin ve mantıksal değerler dahil)",
                syntax: "MINA(değer1, [değer2, ...])",
            },
            { name: "MODEMULT", description: "Çoklu mod", syntax: "MODEMULT(sayı1, [sayı2, ...])" },
            { name: "MODESNGL", description: "Tekli mod", syntax: "MODESNGL(sayı1, [sayı2, ...])" },
            {
                name: "NORMDIST",
                description: "Normal dağılım",
                syntax: "NORMDIST(x, ortalama, standart_sapma, kümülatif)",
            },
            {
                name: "NORMINV",
                description: "Normal dağılımın tersi",
                syntax: "NORMINV(olasılık, ortalama, standart_sapma)",
            },
            { name: "NORMSDIST", description: "Standart normal dağılım", syntax: "NORMSDIST(z, kümülatif)" },
            { name: "NORMSINV", description: "Standart normal dağılımın tersi", syntax: "NORMSINV(olasılık)" },
            { name: "PEARSON", description: "Pearson korelasyon katsayısı", syntax: "PEARSON(dizi1, dizi2)" },
            { name: "PERCENTILEEXC", description: "Yüzdelik (0-1 aralığı hariç)", syntax: "PERCENTILEEXC(dizi, k)" },
            { name: "PERCENTILEINC", description: "Yüzdelik (0-1 aralığı dahil)", syntax: "PERCENTILEINC(dizi, k)" },
            {
                name: "PERCENTRANKEXC",
                description: "Yüzde sırası (0-1 aralığı hariç)",
                syntax: "PERCENTRANKEXC(dizi, x, [ondalık])",
            },
            {
                name: "PERCENTRANKINC",
                description: "Yüzde sırası (0-1 aralığı dahil)",
                syntax: "PERCENTRANKINC(dizi, x, [ondalık])",
            },
            { name: "PERMUT", description: "Permütasyon sayısı", syntax: "PERMUT(n, r)" },
            { name: "PERMUTATIONA", description: "Tekrarlı permütasyon sayısı", syntax: "PERMUTATIONA(n, r)" },
            { name: "PHI", description: "Standart normal dağılım olasılık yoğunluk fonksiyonu", syntax: "PHI(x)" },
            { name: "POISSONDIST", description: "Poisson dağılımı", syntax: "POISSONDIST(x, ortalama, kümülatif)" },
            { name: "PROB", description: "Olasılık", syntax: "PROB(x_dizi, olasılık_dizi, alt_limit, [üst_limit])" },
            { name: "QUARTILEEXC", description: "Çeyrek (0-1 aralığı hariç)", syntax: "QUARTILEEXC(dizi, çeyrek)" },
            { name: "QUARTILEINC", description: "Çeyrek (0-1 aralığı dahil)", syntax: "QUARTILEINC(dizi, çeyrek)" },
            { name: "RANKAVG", description: "Sıralama (ortalama)", syntax: "RANKAVG(sayı, referans, [sıralama])" },
            { name: "RANKEQ", description: "Sıralama (eşit)", syntax: "RANKEQ(sayı, referans, [sıralama])" },
            { name: "RSQ", description: "R-kare değeri", syntax: "RSQ(bilinen_y, bilinen_x)" },
            { name: "SKEW", description: "Çarpıklık", syntax: "SKEW(sayı1, [sayı2, ...])" },
            { name: "SKEWP", description: "Ana kütle çarpıklığı", syntax: "SKEWP(sayı1, [sayı2, ...])" },
            { name: "SLOPE", description: "Doğrusal regresyon eğimi", syntax: "SLOPE(bilinen_y, bilinen_x)" },
            { name: "SMALL", description: "En küçük k. değer", syntax: "SMALL(dizi, k)" },
            {
                name: "STANDARDIZE",
                description: "Standartlaştırılmış değer",
                syntax: "STANDARDIZE(x, ortalama, standart_sapma)",
            },
            {
                name: "STDEVA",
                description: "Standart sapma (metin ve mantıksal değerler dahil)",
                syntax: "STDEVA(değer1, [değer2, ...])",
            },
            { name: "STDEVP", description: "Ana kütle standart sapması", syntax: "STDEVP(sayı1, [sayı2, ...])" },
            {
                name: "STDEVPA",
                description: "Ana kütle standart sapması (metin ve mantıksal değerler dahil)",
                syntax: "STDEVPA(değer1, [değer2, ...])",
            },
            { name: "STDEVS", description: "Örneklem standart sapması", syntax: "STDEVS(sayı1, [sayı2, ...])" },
            { name: "STEYX", description: "Regresyonda standart hata", syntax: "STEYX(bilinen_y, bilinen_x)" },
            { name: "TDIST", description: "t dağılımı", syntax: "TDIST(x, serbestlik_derecesi, kuyruklar)" },
            { name: "TINV", description: "t dağılımının tersi", syntax: "TINV(olasılık, serbestlik_derecesi)" },
            { name: "TRIMMEAN", description: "Kırpılmış ortalama", syntax: "TRIMMEAN(dizi, yüzde)" },
            {
                name: "VARA",
                description: "Varyans (metin ve mantıksal değerler dahil)",
                syntax: "VARA(değer1, [değer2, ...])",
            },
            { name: "VARP", description: "Ana kütle varyansı", syntax: "VARP(sayı1, [sayı2, ...])" },
            {
                name: "VARPA",
                description: "Ana kütle varyansı (metin ve mantıksal değerler dahil)",
                syntax: "VARPA(değer1, [değer2, ...])",
            },
            { name: "VARS", description: "Örneklem varyansı", syntax: "VARS(sayı1, [sayı2, ...])" },
            { name: "WEIBULLDIST", description: "Weibull dağılımı", syntax: "WEIBULLDIST(x, alfa, beta, kümülatif)" },
            { name: "ZTEST", description: "z-testi", syntax: "ZTEST(dizi, x, [sigma])" },
        ],
    },
    {
        key: "financial",
        label: "Finansal",
        functions: [
            {
                name: "ACCRINT",
                description: "Periyodik ödemeli menkul kıymetin tahakkuk eden faizini hesaplar",
                syntax: "ACCRINT(ihraç_tarihi, ilk_faiz_tarihi, çözüm_tarihi, oran, anapara, frekans, [temel])",
            },
            {
                name: "CUMIPMT",
                description: "Bir yatırımın belirli dönemleri arasındaki birikmiş faizini hesaplar",
                syntax: "CUMIPMT(oran, nper, pv, başlangıç_dönemi, bitiş_dönemi, tür)",
            },
            {
                name: "CUMPRINC",
                description: "Bir yatırımın belirli dönemleri arasındaki birikmiş anapara ödemesini hesaplar",
                syntax: "CUMPRINC(oran, nper, pv, başlangıç_dönemi, bitiş_dönemi, tür)",
            },
            {
                name: "DB",
                description:
                    "Sabit azalan bakiye yöntemi kullanarak bir varlığın belirli dönem için amortismanını hesaplar",
                syntax: "DB(maliyet, hurda_değeri, ömür, dönem, [ay])",
            },
            {
                name: "DDB",
                description:
                    "Çift azalan bakiye yöntemi kullanarak bir varlığın belirli dönem için amortismanını hesaplar",
                syntax: "DDB(maliyet, hurda_değeri, ömür, dönem, [faktör])",
            },
            {
                name: "DOLLARDE",
                description: "Kesirli dolar değerini ondalık dolar değerine dönüştürür",
                syntax: "DOLLARDE(kesirli_dolar, kesir)",
            },
            {
                name: "DOLLARFR",
                description: "Ondalık dolar değerini kesirli dolar değerine dönüştürür",
                syntax: "DOLLARFR(ondalık_dolar, kesir)",
            },
            {
                name: "EFFECT",
                description: "Efektif yıllık faiz oranını hesaplar",
                syntax: "EFFECT(nominal_oran, npery)",
            },
            {
                name: "FV",
                description: "Bir yatırımın gelecekteki değerini hesaplar",
                syntax: "FV(oran, nper, pmt, [pv], [tür])",
            },
            {
                name: "FVSCHEDULE",
                description: "Başlangıç anaparasına değişken faiz oranları uygulanarak gelecekteki değeri hesaplar",
                syntax: "FVSCHEDULE(anapara, oranlar)",
            },
            {
                name: "IPMT",
                description: "Bir yatırımın belirli bir dönem için faiz ödemesini hesaplar",
                syntax: "IPMT(oran, dönem, nper, pv, [fv], [tür])",
            },
            {
                name: "IRR",
                description: "Bir dizi nakit akışı için iç verim oranını hesaplar",
                syntax: "IRR(değerler, [tahmin])",
            },
            {
                name: "ISPMT",
                description: "Bir yatırımın belirli bir dönem için ödenen faizini hesaplar",
                syntax: "ISPMT(oran, dönem, nper, pv)",
            },
            {
                name: "MIRR",
                description:
                    "Pozitif ve negatif nakit akışlarının farklı oranlarda finanse edildiği durumlarda değiştirilmiş iç verim oranını hesaplar",
                syntax: "MIRR(değerler, finansman_oranı, yeniden_yatırım_oranı)",
            },
            {
                name: "NOMINAL",
                description: "Nominal yıllık faiz oranını hesaplar",
                syntax: "NOMINAL(etkin_oran, npery)",
            },
            {
                name: "NPER",
                description: "Bir yatırım için gereken dönem sayısını hesaplar",
                syntax: "NPER(oran, pmt, pv, [fv], [tür])",
            },
            {
                name: "NPV",
                description: "Belirli bir iskonto oranını kullanarak bir yatırımın net bugünkü değerini hesaplar",
                syntax: "NPV(oran, değer1, [değer2, ...])",
            },
            {
                name: "PDURATION",
                description:
                    "Belirtilen oranda bir yatırımın belirli bir değere ulaşması için gereken dönem sayısını hesaplar",
                syntax: "PDURATION(oran, pv, fv)",
            },
            {
                name: "PMT",
                description: "Bir anüitenin dönemsel ödeme tutarını hesaplar",
                syntax: "PMT(oran, nper, pv, [fv], [tür])",
            },
            {
                name: "PPMT",
                description: "Bir yatırımın belirli bir dönem için anapara ödemesini hesaplar",
                syntax: "PPMT(oran, dönem, nper, pv, [fv], [tür])",
            },
            {
                name: "PV",
                description: "Bir yatırımın bugünkü değerini hesaplar",
                syntax: "PV(oran, nper, pmt, [fv], [tür])",
            },
            {
                name: "RATE",
                description: "Bir anüitenin dönem başına faiz oranını hesaplar",
                syntax: "RATE(nper, pmt, pv, [fv], [tür], [tahmin])",
            },
        ],
    },
    {
        key: "date",
        label: "Tarih",
        functions: [
            { name: "DATE", description: "Tarih oluşturur", syntax: "DATE(yıl, ay, gün)" },
            {
                name: "DATEVALUE",
                description: "Metin olarak verilen tarihi tarih değerine dönüştürür",
                syntax: "DATEVALUE(tarih_metni)",
            },
            { name: "DAY", description: "Tarihin gününü alır", syntax: "DAY(tarih)" },
            { name: "MONTH", description: "Tarihin ayını alır", syntax: "MONTH(tarih)" },
            { name: "YEAR", description: "Tarihin yılını alır", syntax: "YEAR(tarih)" },
            { name: "TODAY", description: "Bugünün tarihini alır", syntax: "TODAY()" },
            { name: "NOW", description: "Şu anki tarih ve saati alır", syntax: "NOW()" },
            {
                name: "DAYS",
                description: "İki tarih arasındaki gün sayısını hesaplar",
                syntax: "DAYS(bitiş_tarihi, başlangıç_tarihi)",
            },
            {
                name: "DAYS360",
                description: "360 günlük yıl kullanarak iki tarih arasındaki gün sayısını hesaplar",
                syntax: "DAYS360(başlangıç_tarihi, bitiş_tarihi, [yöntem])",
            },
            {
                name: "EDATE",
                description: "Belirli bir tarihten ay sayısını ekler/çıkarır",
                syntax: "EDATE(başlangıç_tarihi, ay_sayısı)",
            },
            {
                name: "EOMONTH",
                description: "Belirli bir ayın son gününü döndürür",
                syntax: "EOMONTH(başlangıç_tarihi, ay_sayısı)",
            },
            { name: "HOUR", description: "Bir zaman değerinin saat bileşenini verir", syntax: "HOUR(zaman)" },
            { name: "MINUTE", description: "Bir zaman değerinin dakika bileşenini verir", syntax: "MINUTE(zaman)" },
            { name: "SECOND", description: "Bir zaman değerinin saniye bileşenini verir", syntax: "SECOND(zaman)" },
            { name: "TIME", description: "Bir zaman değeri oluşturur", syntax: "TIME(saat, dakika, saniye)" },
            {
                name: "TIMEVALUE",
                description: "Metin olarak verilen zamanı zaman değerine dönüştürür",
                syntax: "TIMEVALUE(zaman_metni)",
            },
            {
                name: "WEEKDAY",
                description: "Tarihin haftanın hangi günü olduğunu verir",
                syntax: "WEEKDAY(tarih, [tür])",
            },
            {
                name: "WEEKNUM",
                description: "Tarihin yılın kaçıncı haftası olduğunu verir",
                syntax: "WEEKNUM(tarih, [dönüş_türü])",
            },
            { name: "ISOWEEKNUM", description: "Tarihin ISO hafta numarasını verir", syntax: "ISOWEEKNUM(tarih)" },
            {
                name: "WORKDAY",
                description: "Belirli bir iş günü sayısı ekleyerek tarih döndürür",
                syntax: "WORKDAY(başlangıç_tarihi, gün_sayısı, [tatiller])",
            },
            {
                name: "WORKDAYINTL",
                description: "Uluslararası hafta sonu ayarlarına göre iş günü ekler",
                syntax: "WORKDAYINTL(başlangıç_tarihi, gün_sayısı, [hafta_sonu], [tatiller])",
            },
            {
                name: "NETWORKDAYS",
                description: "İki tarih arasındaki iş günü sayısını verir",
                syntax: "NETWORKDAYS(başlangıç_tarihi, bitiş_tarihi, [tatiller])",
            },
            {
                name: "NETWORKDAYSINTL",
                description: "Uluslararası hafta sonu ayarlarına göre iş günü sayısını verir",
                syntax: "NETWORKDAYSINTL(başlangıç_tarihi, bitiş_tarihi, [hafta_sonu], [tatiller])",
            },
            {
                name: "YEARFRAC",
                description: "İki tarih arasındaki tam yıl kesrini hesaplar",
                syntax: "YEARFRAC(başlangıç_tarihi, bitiş_tarihi, [hesaplama_yöntemi])",
            },
        ],
    },
    {
        key: "text",
        label: "Metin",
        functions: [
            {
                name: "CHAR",
                description: "Belirtilen karakter koduna karşılık gelen karakteri döndürür",
                syntax: "CHAR(kod)",
            },
            { name: "CLEAN", description: "Metinden yazdırılamayan karakterleri kaldırır", syntax: "CLEAN(metin)" },
            {
                name: "CODE",
                description: "Bir metnin ilk karakterinin karakter kodunu döndürür",
                syntax: "CODE(metin)",
            },
            { name: "CONCATENATE", description: "Metinleri birleştirir", syntax: "CONCATENATE(metin1, [metin2, ...])" },
            {
                name: "EXACT",
                description: "İki metnin tamamen aynı olup olmadığını kontrol eder (büyük-küçük harf duyarlı)",
                syntax: "EXACT(metin1, metin2)",
            },
            {
                name: "FIND",
                description: "Bir metnin içinde başka bir metni bulur (büyük-küçük harf duyarlı)",
                syntax: "FIND(aranan_metin, içinde_aranan, [başlangıç_konumu])",
            },
            {
                name: "LEFT",
                description: "Soldan belirli sayıda karakter alır",
                syntax: "LEFT(metin, karakter_sayısı)",
            },
            { name: "LEN", description: "Metnin karakter sayısını verir", syntax: "LEN(metin)" },
            { name: "LOWER", description: "Metni küçük harfe çevirir", syntax: "LOWER(metin)" },
            {
                name: "MID",
                description: "Ortadan belirli sayıda karakter alır",
                syntax: "MID(metin, başlangıç, karakter_sayısı)",
            },
            {
                name: "NUMBERVALUE",
                description: "Metni sayıya dönüştürür (bölgesel ayarlara göre)",
                syntax: "NUMBERVALUE(metin, [ondalık_ayırıcı], [grup_ayırıcı])",
            },
            { name: "PROPER", description: "Her sözcüğün ilk harfini büyük yapar", syntax: "PROPER(metin)" },
            {
                name: "REGEXEXTRACT",
                description: "Düzenli ifade kullanarak metinden eşleşen kısmı çıkarır",
                syntax: "REGEXEXTRACT(metin, düzenli_ifade)",
            },
            {
                name: "REGEXMATCH",
                description: "Bir metnin düzenli ifadeyle eşleşip eşleşmediğini kontrol eder",
                syntax: "REGEXMATCH(metin, düzenli_ifade)",
            },
            {
                name: "REGEXREPLACE",
                description: "Düzenli ifade kullanarak metni değiştirir",
                syntax: "REGEXREPLACE(metin, düzenli_ifade, yeni_metin)",
            },
            {
                name: "REPLACE",
                description: "Metinde belirli bir konumdan itibaren karakterleri değiştirir",
                syntax: "REPLACE(metin, konum, uzunluk, yeni_metin)",
            },
            { name: "REPT", description: "Metni belirtilen sayıda tekrarlar", syntax: "REPT(metin, tekrar_sayısı)" },
            {
                name: "RIGHT",
                description: "Sağdan belirli sayıda karakter alır",
                syntax: "RIGHT(metin, karakter_sayısı)",
            },
            { name: "ROMAN", description: "Sayıyı Roma rakamına dönüştürür", syntax: "ROMAN(sayı)" },
            {
                name: "SEARCH",
                description: "Bir metnin içinde başka bir metni bulur (büyük-küçük harf duyarsız)",
                syntax: "SEARCH(aranan_metin, içinde_aranan, [başlangıç_konumu])",
            },
            { name: "SPLIT", description: "Belirli bir ayırıcıya göre metni böler", syntax: "SPLIT(metin, ayırıcı)" },
            {
                name: "SUBSTITUTE",
                description: "Metinde belirli metni başka bir metinle değiştirir",
                syntax: "SUBSTITUTE(metin, eski_metin, yeni_metin, [tekrar_sayısı])",
            },
            { name: "T", description: "Metni döndürür, metin değilse boş metin döndürür", syntax: "T(değer)" },
            {
                name: "TEXTJOIN",
                description: "Birden çok metin aralığını birleştirir ve aralara belirtilen ayırıcıyı koyar",
                syntax: "TEXTJOIN(ayırıcı, boş_yoksay, metin1, [metin2, ...])",
            },
            { name: "TRIM", description: "Baştaki ve sondaki boşlukları kaldırır", syntax: "TRIM(metin)" },
            {
                name: "UNICHAR",
                description: "Unicode karakter koduna karşılık gelen karakteri döndürür",
                syntax: "UNICHAR(kod)",
            },
            {
                name: "UNICODE",
                description: "Metindeki ilk karakterin Unicode değerini döndürür",
                syntax: "UNICODE(metin)",
            },
            { name: "UPPER", description: "Metni büyük harfe çevirir", syntax: "UPPER(metin)" },
        ],
    },
    {
        key: "logical",
        label: "Mantıksal",
        functions: [
            { name: "IF", description: "Koşula göre değer döndürür", syntax: "IF(koşul, doğruysa, yanlışsa)" },
            {
                name: "IFS",
                description: "Birden fazla koşul için değer döndürür",
                syntax: "IFS(koşul1, değer1, koşul2, değer2, ...)",
            },
            {
                name: "SWITCH",
                description: "Belirtilen değeri koşullarla karşılaştırır ve eşleşen değeri döndürür",
                syntax: "SWITCH(değer, koşul1, sonuç1, [koşul2, sonuç2, ...], [varsayılan])",
            },
            { name: "AND", description: "Tüm koşullar doğruysa TRUE döndürür", syntax: "AND(koşul1, [koşul2, ...])" },
            {
                name: "OR",
                description: "Herhangi bir koşul doğruysa TRUE döndürür",
                syntax: "OR(koşul1, [koşul2, ...])",
            },
            {
                name: "XOR",
                description: "Tek sayıda koşul doğruysa TRUE döndürür",
                syntax: "XOR(koşul1, [koşul2, ...])",
            },
            { name: "NOT", description: "Mantıksal değeri tersine çevirir", syntax: "NOT(mantıksal)" },
            { name: "TRUE", description: "TRUE değerini döndürür", syntax: "TRUE()" },
            { name: "FALSE", description: "FALSE değerini döndürür", syntax: "FALSE()" },
            {
                name: "IFERROR",
                description: "Hata varsa belirtilen değeri döndürür",
                syntax: "IFERROR(değer, hata_varsa)",
            },
            {
                name: "IFNA",
                description: "#N/A hatası varsa belirtilen değeri döndürür",
                syntax: "IFNA(değer, na_hatası_varsa)",
            },
        ],
    },
    {
        key: "engineering",
        label: "Mühendislik",
        functions: [
            { name: "BIN2DEC", description: "İkili sayıyı ondalık sayıya dönüştürür", syntax: "BIN2DEC(ikili_sayı)" },
            {
                name: "BIN2HEX",
                description: "İkili sayıyı onaltılık sayıya dönüştürür",
                syntax: "BIN2HEX(ikili_sayı, [basamak])",
            },
            {
                name: "BIN2OCT",
                description: "İkili sayıyı sekizli sayıya dönüştürür",
                syntax: "BIN2OCT(ikili_sayı, [basamak])",
            },
            {
                name: "BITAND",
                description: "İki sayının bit düzeyinde VE (AND) işlemini yapar",
                syntax: "BITAND(sayı1, sayı2)",
            },
            {
                name: "BITLSHIFT",
                description: "Sayının bit düzeyinde sola kaydırma işlemini yapar",
                syntax: "BITLSHIFT(sayı, kaydırma_miktarı)",
            },
            {
                name: "BITOR",
                description: "İki sayının bit düzeyinde VEYA (OR) işlemini yapar",
                syntax: "BITOR(sayı1, sayı2)",
            },
            {
                name: "BITRSHIFT",
                description: "Sayının bit düzeyinde sağa kaydırma işlemini yapar",
                syntax: "BITRSHIFT(sayı, kaydırma_miktarı)",
            },
            {
                name: "BITXOR",
                description: "İki sayının bit düzeyinde XOR işlemini yapar",
                syntax: "BITXOR(sayı1, sayı2)",
            },
            {
                name: "COMPLEX",
                description: "Gerçek ve sanal katsayılardan karmaşık sayı oluşturur",
                syntax: "COMPLEX(gerçek_katsayı, sanal_katsayı, [birim])",
            },
            {
                name: "CONVERT",
                description: "Bir ölçüm biriminden diğerine dönüştürür",
                syntax: "CONVERT(sayı, kaynak_birim, hedef_birim)",
            },
            {
                name: "DEC2BIN",
                description: "Ondalık sayıyı ikili sayıya dönüştürür",
                syntax: "DEC2BIN(ondalık_sayı, [basamak])",
            },
            {
                name: "DEC2HEX",
                description: "Ondalık sayıyı onaltılık sayıya dönüştürür",
                syntax: "DEC2HEX(ondalık_sayı, [basamak])",
            },
            {
                name: "DEC2OCT",
                description: "Ondalık sayıyı sekizli sayıya dönüştürür",
                syntax: "DEC2OCT(ondalık_sayı, [basamak])",
            },
            {
                name: "DELTA",
                description: "İki değerin eşit olup olmadığını test eder (Kronecker delta)",
                syntax: "DELTA(sayı1, [sayı2])",
            },
            { name: "ERF", description: "Hata fonksiyonunu hesaplar", syntax: "ERF(alt_limit, [üst_limit])" },
            { name: "ERFC", description: "Tamamlayıcı hata fonksiyonunu hesaplar", syntax: "ERFC(x)" },
            {
                name: "GESTEP",
                description: "Sayının eşik değerden büyük veya eşit olup olmadığını test eder",
                syntax: "GESTEP(sayı, [adım])",
            },
            {
                name: "HEX2BIN",
                description: "Onaltılık sayıyı ikili sayıya dönüştürür",
                syntax: "HEX2BIN(onaltılık_sayı, [basamak])",
            },
            {
                name: "HEX2DEC",
                description: "Onaltılık sayıyı ondalık sayıya dönüştürür",
                syntax: "HEX2DEC(onaltılık_sayı)",
            },
            {
                name: "HEX2OCT",
                description: "Onaltılık sayıyı sekizli sayıya dönüştürür",
                syntax: "HEX2OCT(onaltılık_sayı, [basamak])",
            },
            {
                name: "IMABS",
                description: "Karmaşık sayının mutlak değerini (modülünü) hesaplar",
                syntax: "IMABS(karmaşık_sayı)",
            },
            {
                name: "IMAGINARY",
                description: "Karmaşık sayının sanal katsayısını döndürür",
                syntax: "IMAGINARY(karmaşık_sayı)",
            },
            {
                name: "IMARGUMENT",
                description: "Karmaşık sayının argümanını (teta açısını) döndürür",
                syntax: "IMARGUMENT(karmaşık_sayı)",
            },
            {
                name: "IMCONJUGATE",
                description: "Karmaşık sayının eşleniğini döndürür",
                syntax: "IMCONJUGATE(karmaşık_sayı)",
            },
            { name: "IMCOS", description: "Karmaşık sayının kosinüsünü hesaplar", syntax: "IMCOS(karmaşık_sayı)" },
            {
                name: "IMCOSH",
                description: "Karmaşık sayının hiperbolik kosinüsünü hesaplar",
                syntax: "IMCOSH(karmaşık_sayı)",
            },
            { name: "IMCOT", description: "Karmaşık sayının kotanjantını hesaplar", syntax: "IMCOT(karmaşık_sayı)" },
            { name: "IMCSC", description: "Karmaşık sayının kosekantını hesaplar", syntax: "IMCSC(karmaşık_sayı)" },
            {
                name: "IMCSCH",
                description: "Karmaşık sayının hiperbolik kosekantını hesaplar",
                syntax: "IMCSCH(karmaşık_sayı)",
            },
            {
                name: "IMDIV",
                description: "İki karmaşık sayının bölümünü hesaplar",
                syntax: "IMDIV(karmaşık_sayı1, karmaşık_sayı2)",
            },
            { name: "IMEXP", description: "Karmaşık sayının e üssünü hesaplar", syntax: "IMEXP(karmaşık_sayı)" },
            {
                name: "IMLN",
                description: "Karmaşık sayının doğal logaritmasını hesaplar",
                syntax: "IMLN(karmaşık_sayı)",
            },
            {
                name: "IMLOG10",
                description: "Karmaşık sayının 10 tabanında logaritmasını hesaplar",
                syntax: "IMLOG10(karmaşık_sayı)",
            },
            {
                name: "IMLOG2",
                description: "Karmaşık sayının 2 tabanında logaritmasını hesaplar",
                syntax: "IMLOG2(karmaşık_sayı)",
            },
            { name: "IMPOWER", description: "Karmaşık sayının üssünü hesaplar", syntax: "IMPOWER(karmaşık_sayı, üs)" },
            {
                name: "IMPRODUCT",
                description: "Karmaşık sayıların çarpımını hesaplar",
                syntax: "IMPRODUCT(karmaşık_sayı1, [karmaşık_sayı2, ...])",
            },
            {
                name: "IMREAL",
                description: "Karmaşık sayının gerçek katsayısını döndürür",
                syntax: "IMREAL(karmaşık_sayı)",
            },
            { name: "IMSEC", description: "Karmaşık sayının sekantını hesaplar", syntax: "IMSEC(karmaşık_sayı)" },
            {
                name: "IMSECH",
                description: "Karmaşık sayının hiperbolik sekantını hesaplar",
                syntax: "IMSECH(karmaşık_sayı)",
            },
            { name: "IMSIN", description: "Karmaşık sayının sinüsünü hesaplar", syntax: "IMSIN(karmaşık_sayı)" },
            {
                name: "IMSINH",
                description: "Karmaşık sayının hiperbolik sinüsünü hesaplar",
                syntax: "IMSINH(karmaşık_sayı)",
            },
            { name: "IMSQRT", description: "Karmaşık sayının karekökünü hesaplar", syntax: "IMSQRT(karmaşık_sayı)" },
            {
                name: "IMSUB",
                description: "İki karmaşık sayının farkını hesaplar",
                syntax: "IMSUB(karmaşık_sayı1, karmaşık_sayı2)",
            },
            {
                name: "IMSUM",
                description: "Karmaşık sayıların toplamını hesaplar",
                syntax: "IMSUM(karmaşık_sayı1, [karmaşık_sayı2, ...])",
            },
            { name: "IMTAN", description: "Karmaşık sayının tanjantını hesaplar", syntax: "IMTAN(karmaşık_sayı)" },
            {
                name: "OCT2BIN",
                description: "Sekizli sayıyı ikili sayıya dönüştürür",
                syntax: "OCT2BIN(sekizli_sayı, [basamak])",
            },
            {
                name: "OCT2DEC",
                description: "Sekizli sayıyı ondalık sayıya dönüştürür",
                syntax: "OCT2DEC(sekizli_sayı)",
            },
            {
                name: "OCT2HEX",
                description: "Sekizli sayıyı onaltılık sayıya dönüştürür",
                syntax: "OCT2HEX(sekizli_sayı, [basamak])",
            },
        ],
    },
];
